<template>
  <div class="grid-x align-center margin-top-xs">
    <Picture :image-url="taglineAssetSrc" alt="Like No Other Store in the World" :aspect-ratio="16.45" :using-scene7="false" />
  </div>
</template>

<script setup>
import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';
import getAssetImage from '~/utils/getAssetImage';

const taglineAssetSrc = getAssetImage('tagline.svg');
</script>
